import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store.js";

import BootstrapVue from "bootstrap-vue";

import "vue-popperjs/dist/vue-popper.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "bootstrap-select/dist/css/bootstrap-select.min.css";
import "bootstrap-select/dist/js/bootstrap-select.min.js";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

import VueAnalytics from "vue-analytics";

Vue.use(VueAnalytics, {
  id: "UA-163231357-1",
  router
});

Sentry.init({
  dsn:
    "https://8eb41f98b78049f1977657937e468ca6@o160096.ingest.sentry.io/5195519",
  integrations: [new Integrations.Vue({ Vue, attachProps: true })]
});

Vue.config.productionTip = false;

Vue.use(BootstrapVue);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
